import CardContent from './Card';
import Body from './Body';
import Footer from './Footer';
import Header from './Header';

export const Card = { CardContent, Body, Footer, Header };